import React from 'react'

const ImageIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#0087FF"
        d="M3.066 17.979C1.026 17.979 0 16.973 0 14.96V3.027C0 1.016 1.025 0 3.066 0h16.895c2.05 0 3.066 1.016 3.066 3.027v11.934c0 2.012-1.015 3.018-3.066 3.018H3.066Zm13.155-8.995 5.234 4.912V3.117c0-1.016-.547-1.544-1.514-1.544H3.086c-.977 0-1.514.528-1.514 1.543v10.781l2.91-2.627c.4-.37.82-.546 1.26-.546.46 0 .908.185 1.319.556l1.806 1.631 4.414-3.945c.45-.4.928-.586 1.465-.586.527 0 1.045.205 1.475.605Zm-8.946.098a2.309 2.309 0 0 1-2.304-2.305 2.315 2.315 0 0 1 2.304-2.304c1.26 0 2.295 1.045 2.295 2.304a2.307 2.307 0 0 1-2.295 2.305Z"
      />
    </svg>
  )
}

export default ImageIcon
